var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisible1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.779 16.5502C26.1969 21.1872 21.2999 24.0678 16.0017 24.0678C10.7 24.0678 5.80311 21.1872 3.22086 16.5502C3.02198 16.1901 3.02198 15.8095 3.22086 15.4497C5.80311 10.8127 10.7 7.93247 16.0017 7.93247C21.2999 7.93247 26.1968 10.8127 28.779 15.4497C28.9814 15.8095 28.9814 16.1901 28.779 16.5502ZM30.4285 14.5303C27.5137 9.29491 21.9857 6.04297 16.0017 6.04297C10.0142 6.04297 4.48623 9.29491 1.57136 14.5303C1.05011 15.4645 1.05011 16.5354 1.57136 17.4688C4.48623 22.7043 10.0142 25.9569 16.0017 25.9569C21.9857 25.9569 27.5137 22.7043 30.4285 17.4688C30.9498 16.5355 30.9498 15.4645 30.4285 14.5303ZM16.0017 19.8758C18.1381 19.8758 19.8767 18.1372 19.8767 15.9998C19.8767 13.8623 18.1381 12.1237 16.0017 12.1237C13.8618 12.1237 12.1232 13.8623 12.1232 15.9998C12.1232 18.1372 13.8619 19.8758 16.0017 19.8758ZM16.0017 10.2342C12.8193 10.2342 10.2337 12.8209 10.2337 15.9998C10.2337 19.1795 12.8194 21.7651 16.0017 21.7651C19.1806 21.7651 21.7662 19.1794 21.7662 15.9998C21.7662 12.8209 19.1806 10.2342 16.0017 10.2342Z",
    fill: "#5D616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible1);
export default __webpack_public_path__ + "static/media/visible 1.30da0f4f235f87f33bd5a2eea616e80d.svg";
export { ForwardRef as ReactComponent };